export class ContentSearchCriteria {
  nameCriteria: string;

  pageNumber = 1;
  pageSize = 25;

  constructor() {}
}
